export const ASYNC_ACTION_START = "ASYNC_ACTION_START";

export const ASYNC_ACTION_FINISH = "ASYNC_ACTION_FINISH";

export const ASYNC_ACTION_ERROR = "ASYNC_ACTION_ERROR";



// WEBPACK FOOTER //
// ./src/features/async/asyncConstants.jsx